import React from "react";
import { Backdrop, CircularProgress, Theme } from "@mui/material";

import makeStyles from "@mui/styles/makeStyles";

type Props = {
  open: boolean;
  "data-testid"?: string;
};

const useStyles = makeStyles((theme: Theme) => ({
  backdrop: {
    zIndex: theme.zIndex.modal + 1,
    color: "#fff",
  },
}));

export function Loader({ open, "data-testid": dataTestId }: Props): React.ReactElement {
  const classes = useStyles();

  return (
    <>
      <Backdrop className={classes.backdrop} open={open}>
        <CircularProgress color="inherit" data-testid={dataTestId} />
      </Backdrop>
    </>
  );
}
